import { put, all, takeLatest, select } from 'redux-saga/effects';
import { RequerimentoService } from '@services';
import {
  obterFormulariosSuccess,
  obterLabelFormulariosSuccess,
  obterPeritosSuccess,
  obterStatusRequerimentosSuccess,
} from './actions';
import {
  OBTER_PERITOS_REQUEST,
  OBTER_REQUERIMENTOS_REQUEST,
  OBTER_TODOS_FORMULARIOS_REQUEST,
} from './constants';
import { hideLoad, showLoad } from '../loading/actions';

function* obterPeritosRequest() {
  const service = new RequerimentoService();
  const medicosPeritos = yield service.obterMedicosPeritos();
  yield put(obterPeritosSuccess(medicosPeritos));
}

function* obterRequerimentosPorStatus({ status }) {
  yield put(showLoad());
  const user = yield select((state) => state.user);

  const service = new RequerimentoService();
  const response = yield service.obterStatusRequerimento({
    matricula: user.matricula,
    token: user.token,
    status,
  });

  if (response.data) {
    const arrayAnexosPendentesPromises = yield response.data.map(
      (requerimento) => {
        const anexosPendentes = service
          .obterAnexosPendentesPorProtocolo({
            protocolo: requerimento.Protocolo,
            matricula: user.matricula,
            token: user.token,
          })
          .then((request) => {
            return { ...requerimento, anexosPendentes: request.data };
          })
          .catch(() => requerimento);

        return anexosPendentes;
      }
    );

    const arrayRequerimentosComAnexosPendentes = yield Promise.all(
      arrayAnexosPendentesPromises
    );

    yield put(
      obterStatusRequerimentosSuccess({
        status,
        data: arrayRequerimentosComAnexosPendentes,
      })
    );
  }

  yield put(hideLoad());
}

function* obterTodosOsFormularios() {
  const service = new RequerimentoService();
  const user = yield select((state) => state.user);
  const allFormsLabelsRequestDone = yield select(
    (state) => state.requerimento.allFormsLabelsRequestDone
  );

  const { matricula, token, plano, listaPlanos } = user;

  const { sitpart, tipoBeneficio } = listaPlanos.find(
    (plan) => Number(plan.value) === Number(plano)
  );

  try {
    yield put(showLoad());
    const forms = yield service.obterFormulariosDisponiveis({
      matricula,
      token,
      plano,
      sitpart,
      beneficio: tipoBeneficio,
    });

    yield put(obterFormulariosSuccess(forms));

    if (!allFormsLabelsRequestDone) {
      const formLabels = yield service.obterTitulosFormularios();

      const fomatedFormLabels = formLabels.results.map((form) => ({
        referencia: form.Referencia,
        nome: form.Title,
      }));

      yield put(obterLabelFormulariosSuccess(fomatedFormLabels));
    }
  } catch (e) {
    console.error('Erro ao obter todos os requerimentos. ', e);
  } finally {
    yield put(hideLoad());
  }
}

export default all([
  takeLatest(OBTER_PERITOS_REQUEST, obterPeritosRequest),
  takeLatest(OBTER_REQUERIMENTOS_REQUEST, obterRequerimentosPorStatus),
  takeLatest(OBTER_TODOS_FORMULARIOS_REQUEST, obterTodosOsFormularios),
]);
